import React from 'react';
import InlineInput from './InlineInput';
export default function TextView(_a) {
    var text = _a.text;
    var commit = function (value) { text.nodeValue = value; };
    return (React.createElement(InlineInput, { value: text.nodeValue || "", commit: commit }));
}
